module.exports = __webpack_public_path__ + "media/images/payments/unionpay-81d77f96efeb3dda38a5ba10a3086f20.svg";